"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_spring_1 = require("react-spring");
const react_jss_1 = require("react-jss");
const usePrevious_1 = __importDefault(require("../hooks/usePrevious"));
const INITIAL_TIMER = 30;
const useStyles = (0, react_jss_1.createUseStyles)({
    hourglass: {
        height: 50,
        animationName: "$hourglass-rotation",
        animationDuration: "30s",
        animationIterationCount: "infinite",
        // "& #top-sand g path": {
        // 	animationName: "$top-clip",
        // 	animationDuration: "30s",
        // 	animationIterationCount: "infinite",
        // },
        // "& #bottom-sand g path": {
        // 	animationName: "$bottom-clip",
        // 	animationDuration: "30s",
        // 	animationIterationCount: "infinite",
        // },
    },
    "@keyframes top-clip": {
        "0%": {},
        "90%": { transform: "translateY(15px)" },
        "100%": { transform: "translateY(46px)" },
    },
    "@keyframes bottom-clip": {
        "0%": {},
        "100%": { transform: "translateY(-30px)" },
    },
    "@keyframes hourglass-rotation": {
        "50%": { transform: "rotateZ(0)" },
        "99%": { transform: "rotateZ(0)" },
        "99.5%": { transform: "scale(1.3)" }, //translateX(50%)
        "100%": { transform: "rotateZ(180deg)" },
    },
    root: {
        fontFamily: '"Bubblegum Sans", cursive',
        fontSize: 20,
        color: "black",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: 90,
    },
    secondsLeft: {
        width: 35,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginLeft: "auto",
    },
});
const Timer = ({ isPaused, onTimeOut, turnCounter }) => {
    let intervalHandle = null;
    const prevTurnCounter = (0, usePrevious_1.default)(turnCounter);
    const classes = useStyles();
    const [seconds, setSeconds] = (0, react_1.useState)(INITIAL_TIMER);
    const [{ x }, set] = (0, react_spring_1.useSpring)(() => ({ x: 0 }));
    const style = {
        transform: turnCounter % 2 === 0 ? `rotateZ(0deg)` : `rotate(180deg)`,
        transitionDuration: "1s",
        transitionProperty: "transform",
        config: { tension: 20, friction: 20 },
    };
    const bottomStyle = {
    // transform: turnCounter % 2 === 0 ? `translateY(0px)` : "translateY(-30px)",
    // transitionDuration: "1s",
    // transitionProperty: "transform",
    // config: { tension: 20, friction: 20 },
    };
    const topStyle = {
        transform: turnCounter % 2 === 0 ? `rotate(0)` : "rotate(180deg)",
        transformOrigin: "center",
        transitionDuration: "1s",
        transitionProperty: "transform",
        config: { tension: 20, friction: 20 },
    };
    (0, react_1.useEffect)(() => {
        if (turnCounter !== prevTurnCounter) {
            setSeconds(INITIAL_TIMER);
        }
        intervalHandle = setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
            if (seconds === 0) {
                setSeconds(INITIAL_TIMER);
                onTimeOut();
                return;
            }
            if (isPaused === true) {
                return;
            }
            setSeconds(seconds - 1);
        }), 1000);
        return () => {
            clearInterval(intervalHandle);
        };
    }, [turnCounter, seconds, isPaused]);
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(react_spring_1.animated.span, { style: style, onAnimationStart: () => seconds === INITIAL_TIMER },
            react_1.default.createElement("svg", { version: "1.1", id: "hourglass", x: "0px", y: "0px", viewBox: "0 0 84.1 106.5", height: "47px", enableBackground: "new 0 0 84.1 106.5" },
                react_1.default.createElement("path", { id: "glass", fill: "#CCF8FF", d: "M74.4,79.1c0-10.3-7.2-19.2-17.8-23.5c-2.7-1.1-2.7-4.2,0-5.3C67.2,46,74.4,37.1,74.4,26.8V11H9.7v15.8c0,10.3,7.2,19.2,17.8,23.5c2.7,1.1,2.7,4.2,0,5.3C17,60,9.7,68.8,9.7,79.1v16.4h64.7L74.4,79.1L74.4,79.1z" }),
                react_1.default.createElement("path", { id: "bottom-plate", fill: "#DD9F80", d: "M75.4,11h-67c-4.7,0-8.5-2.5-8.5-5.5S3.7,0,8.4,0h67.1C80.2,0,84,2.5,84,5.5C83.9,8.5,80.1,11,75.4,11z" }),
                react_1.default.createElement("path", { id: "top-plate", fill: "#DD9F80", d: "M75.4,95.5h-67c-4.7,0-8.5,2.5-8.5,5.5s3.8,5.5,8.5,5.5h67.1c4.7,0,8.5-2.5,8.5-5.5C83.9,98,80.1,95.5,75.4,95.5z" }),
                react_1.default.createElement("g", { id: "bottom-sand" },
                    react_1.default.createElement("clipPath", { id: "SVGID_00000062900714672112152060000003209405532830297217_" },
                        react_1.default.createElement("rect", { id: "SVGID_1_", x: "-0.1", y: "52.3", width: "83.9", height: "40" })),
                    react_1.default.createElement("g", { clipPath: "url(#SVGID_00000062900714672112152060000003209405532830297217_)" },
                        react_1.default.createElement(react_spring_1.animated.path, { style: bottomStyle, fill: "#EFD4BF", d: "M13.8,123.2V117c8.9-7.3,15.9-13.9,20.8-19.6l0.2-0.2c2.5-3,4.7-4.4,7-4.4c3.2,0,5.7,2.8,7,4.3l0.1,0.1l0.3,0.3c5.1,5.9,11.9,12.5,20.6,19.9v5.9H13.8z" }))),
                react_1.default.createElement("g", { id: "top-sand" },
                    react_1.default.createElement("clipPath", { id: "SVGID_00000075874261675083374320000014012175088842450862_" },
                        react_1.default.createElement("path", { id: "SVGID_00000101079927897190841180000017366869627532568713_", d: "M42.7,22.8C37.4,20.9,31.8,20,25.9,20c-3.9,0-7.8,0.4-11.7,1.3c-0.1,0-0.1,0-0.2,0v3.1c0,8.1,4.3,15.4,11,20c2.7,1.9,5.8,3.3,9.2,4.2c0,0,0,0,0,0c0.2,0.1,0.6,0.2,1,0.3c2.4,0.7,3.1,0.8,4.1,1.4c0.4,0.2,0.6,0.4,0.8,0.6c0.8,0.9,1,2,1.1,3.1v41.5h0h1.5H43V54c0.1-1.1,0.3-2.2,1.1-3.1c0.2-0.3,0.5-0.4,0.8-0.6c1-0.6,1.7-0.8,4.1-1.4c0.4-0.1,0.8-0.2,1-0.3c0,0-0.1,0-0.1,0c3.4-0.9,6.6-2.4,9.3-4.3c5.9-4.1,9.9-10.2,10.7-17.2C64.6,26.8,51,25.7,42.7,22.8z" })),
                    react_1.default.createElement("g", { clipPath: "url(#SVGID_00000075874261675083374320000014012175088842450862_)" },
                        react_1.default.createElement(react_spring_1.animated.path, { style: topStyle, fill: "#EFD4BF", d: "M42.7,22.8C37.4,20.9,31.8,20,25.9,20c-3.9,0-7.8,0.4-11.7,1.3c-0.1,0-0.1,0-0.2,0v3.1c0,8.1,4.3,15.4,11,20c4.7,3.3,10.7,5.2,17.1,5.2c6.5,0,12.5-2,17.2-5.3c5.9-4.1,9.9-10.2,10.7-17.2C64.6,26.8,51,25.7,42.7,22.8z" }))),
                react_1.default.createElement("path", { id: "shadow", opacity: "0.3", fill: "#49AFBF", d: "M34,11c-4.7,0-8.5-2.5-8.5-5.5S29.3,0,34,0H8.3C3.6,0-0.2,2.5-0.2,5.5S3.6,11,8.3,11h1.2v15.8c0,10.3,7.2,19.2,17.8,23.5c0.3,0.1,0.6,0.3,0.9,0.5c0.6,0.5,0.9,1,1.1,1.7v0.1c0.2,1.2-0.5,2.4-2,3C16.7,60,9.4,68.8,9.4,79.1v16.4H8.3c-4.7,0-8.5,2.5-8.5,5.5s3.8,5.5,8.5,5.5H34c-4.7,0-8.5-2.5-8.5-5.5s3.8-5.5,8.5-5.5h-9.2c-2.3-10.4-2.1-20.9,4.6-28.2C38.7,57,38.1,46,35.3,37.5c-2.3-6.8,3-13.8,11.2-14.7c18.8-2.2,27.8-8.9,27.8-8.9V11H34z" }))),
        react_1.default.createElement("div", { className: classes.secondsLeft },
            react_1.default.createElement("div", null, seconds),
            react_1.default.createElement("div", null, "s"))));
};
exports.default = Timer;
